"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerResponse = exports.dataMutation = exports.errorHandler = exports.fetchUrl = exports.buildCustomerUrl = void 0;
var constant_1 = require("./constant");
var buildCustomerUrl = function (listParams) {
    var _a;
    var base = constant_1.CUSTOMER_URL + "?url-safe-cursor=" + ((_a = listParams.cursor) !== null && _a !== void 0 ? _a : '');
    var cursor = listParams.cursor, params = __rest(listParams, ["cursor"]);
    return Object.entries(params).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        return (value ? acc + "&" + key + "=" + value : acc);
    }, base);
};
exports.buildCustomerUrl = buildCustomerUrl;
var fetchUrl = function (listParams) {
    var _a;
    var searchParams = listParams;
    if (searchParams.searchedKeyword) {
        return constant_1.CUSTOMER_URL + "/search?item-size=20&searched-keyword=" + searchParams.searchedKeyword + "&url-safe-cursor=" + ((_a = searchParams.cursor) !== null && _a !== void 0 ? _a : '');
    }
    var customersParams = listParams;
    return exports.buildCustomerUrl(customersParams);
};
exports.fetchUrl = fetchUrl;
var errorHandler = function (err) {
    var _a, _b, _c;
    var error = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data;
    return (error || { status: (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.status, message: (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.data });
};
exports.errorHandler = errorHandler;
var dataMutation = function (customerData) {
    var id = customerData.id, noIdData = __rest(customerData, ["id"]);
    // For obscure reason, if we give hasOptInOut to customer module it return 400 http code
    var hasOptInOut = noIdData.hasOptInOut, data = __rest(noIdData, ["hasOptInOut"]);
    return data;
};
exports.dataMutation = dataMutation;
var customerResponse = function (response) {
    var customer = response;
    // Seems, for create and update,
    // no matter what we do, if there is an error it will return a 400 with en empty body
    return customer.id
        ? Promise.resolve(customer)
        : Promise.reject(response);
};
exports.customerResponse = customerResponse;
